import React from 'react';

import './style.css';

export default function OuterButton(props) {


    return (
        <button className='outer-button' name={props.name} value={props.value} onClick={props.onClick} type={props.type}>
            {props.label}
        </button>
    );
}
